import { useLocation, useNavigate, Link } from 'react-router';
import type { LinkProps } from 'react-router';

export function pageScope(path: string): string {
  const pathname =
    new URL(path, 'https://slad-sl.pages.dev').pathname.replace(/\/$/, '') || '/';
  const work = /^\/work\/([^/]+)/.exec(pathname);
  return work ? `/work/${work[1]}` : pathname;
}

export function needsDocumentNavigation(from: string, to: string): boolean {
  return pageScope(from) !== pageScope(to);
}

export function usePageNavigate() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (to: string) => {
    if (needsDocumentNavigation(pathname, to)) window.location.assign(to);
    else void navigate(to);
  };
}

/** Native anchors between pages also support opening a page in another tab. */
export function PageLink(props: LinkProps) {
  const { pathname } = useLocation();
  const target = typeof props.to === 'string' ? props.to : props.to.pathname || pathname;
  return <Link {...props} reloadDocument={needsDocumentNavigation(pathname, target)} />;
}
